import React, { useCallback, useEffect, useRef, useState } from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Modal from "../../components/FlexFreteModal/Modal";
import FreteService from "../../services/FreteService";
import FlexSpinner from "../FlexFreteSpinner/FlexSpinner";
import MeusenviosFrete from "./MeusEnviosFrete";
import DownloadService from "../../services/DownloadService";
import LoteService from "../../services/LoteService";
import { Container, FreteListSearchForm, SelectStatusFreteStyle, GlobalFilterStyle } from "./style";
import ModalEnvios from "../../components/Modal/ModalEnvios";
import { MultiSelect } from "primereact/multiselect";
import LojaService from "../../services/LojaService";
import AutenticacaoService from "../../services/AutenticacaoService";
const freteService = new FreteService();
const downloadService = new DownloadService();
const etiquetaService = new LoteService();
const lojaService = new LojaService();
const autenticacaoService = new AutenticacaoService();

export default function MeusEnviosFreteList({ section }) {
  const [isLoading, setIsLoading] = useState(false);
  const [checkedAll, setCheckedAll] = useState(false);
  const [fretes, setfretes] = useState([]);
  const [freteSelecionado, setFreteSelecionado] = useState([]);
  const [status, setStatus] = useState(section || "GERADO");
  const [showingItems, setShowingItems] = useState([false]);
  const [submitSearchForm, setSubmitSearchForm] = useState(false);
  const [comoFuncionaPosition, setComoFuncionaPosition] = useState(0);
  const [posicaoFiltros, setPosicaoFiltros] = useState(0);
  const paginasFiltrosRef = useRef(null);

  const [request, setRequest] = useState({
    pageSize: 10,
    page: 0,
    status: section || "GERADO",
    dataInicio: "",
    dataFim: "",
    nomeDestinatario: [],
    cpfCnpj: [],
    codigoEncomenda: [],
    cepDestino: [],
    transportadora: [],
    lojas: [],
  });

  const [labelCheckAll, setLabelCheckAll] = useState("Selecionar todos");
  const [isModalVisible, setModalVisible] = useState(false);
  const [tipoFolha, setTipoFolha] = useState("A4");
  const [bloquearBotao, setBloquearBotao] = useState(false);
  const [imprimirEtiqueta, setImprimirEtiqueta] = useState(true);
  const [imprimirDace, setImprimirDace] = useState(true);

  const tiposImpressao = [
    { label: "A4", value: "A4" },
    { label: "Térmica 10x15", value: "A6" },
  ];

  const usuario = autenticacaoService.usuarioCorrente();
  const isSeller = usuario?.tipoDeAssinatura === "SELLER";

  // Estados dos Filtros Avançados
  const [nomeDestinatarios, setnomeDestinatarios] = useState([]);
  const [cpfCnpjs, setcpfCnpjs] = useState([]);
  const [codigosEncomenda, setCodigosEncomenda] = useState([]);
  const [transportadoras, setTransportadoras] = useState([]);
  const [cepsDestino, setCepsDestino] = useState([]);
  const [lojas, setLojas] = useState([]);

  const formatarMascara = (valor, tipo) => {
    if (!valor) return valor;
    const num = valor.replace(/\D/g, "");

    // Mascara para CPF
    if (tipo === "cpfDestinatario" && num.length === 11) {
      return num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    // Mascara para CNPJ
    if (tipo === "cpfDestinatario" && num.length === 14) {
      return num.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
    // Mascara para CEP
    if (tipo === "cepDestinatario" && num.length === 8) {
      return num.replace(/(\d{5})(\d{3})/, "$1-$2");
    }
    return valor;
  };

  const carregarFiltro = useCallback((type, setter, abaAtual) => {
    const statusAtivo = abaAtual || "GERADO";

    freteService.getEntragaOpcoes(type, statusAtivo, (err, data) => {
      if (err) {
        console.error(`Erro ao buscar opções para ${type}:`, err);
      } else {
        const options = data.map((item) => ({
          label: formatarMascara(item.description, type),
          value: item.uuid,
        }));
        setter(options);
      }
    });
  }, []);

  useEffect(() => {
    carregarFiltro("nomeDestinatario", setnomeDestinatarios, status);
    carregarFiltro("cpfDestinatario", setcpfCnpjs, status);
    carregarFiltro("codigoEncomenda", setCodigosEncomenda, status);
    carregarFiltro("cepDestinatario", setCepsDestino, status);
    carregarFiltro("transportadora", setTransportadoras, status);
  }, [status, carregarFiltro]);

  useEffect(() => {
    if (isSeller) {
      lojaService.obterLojas((err, data) => {
        if (!err) {
          const options = data.map((loja) => ({
            label: loja.nome,
            value: loja.uuid,
          }));
          setLojas(options);
        }
      });
    }
  }, [isSeller]);

  const handleSelectChange = (event) => {
    setTipoFolha(event.target.value);
  };

  const handleFreteChange = (isChecked, frete) => {
    if (isChecked) {
      frete.ischecked = true;
      if (!freteSelecionado.find((f) => f.uuid === frete.uuid)) {
        setFreteSelecionado([...freteSelecionado, frete]);
      }
      if (freteSelecionado.length === fretes.length - 1) {
        setCheckedAll(true);
        setLabelCheckAll("Desmarcar todos");
      }
    } else {
      frete.ischecked = false;
      const newFrete = freteSelecionado.filter((f) => f.uuid !== frete.uuid);
      setFreteSelecionado([...newFrete]);
      setCheckedAll(false);
    }
  };

  const handleFreteChangeAll = (isChecked) => {
    const newFrete = fretes.map((f) => {
      f.ischecked = isChecked;
      return f;
    });
    if (isChecked) {
      setCheckedAll(true);
      setFreteSelecionado([...newFrete]);
      setLabelCheckAll("Desmarcar todos");
    } else {
      setFreteSelecionado([]);
      setCheckedAll(false);
      setLabelCheckAll("Selecionar todos");
    }
  };

  const limparSelecao = () => {
    setFreteSelecionado([]);
    setCheckedAll(false);
    setLabelCheckAll("Selecionar todos");
  };

  const etiquetasLoteModal = () => {
    if (freteSelecionado.length === 0) {
      console.error("Nenhum frete selecionado.");
      return;
    }
    setBloquearBotao(true);
    setModalVisible(true);
  };

  const imprimir = (event, acao) => {
    if (acao !== false) {
      if (!imprimirEtiqueta && !imprimirDace) {
        setErro({
          isWrong: true,
          titulo: "Erro ao imprimir",
          mensagem: "Selecione ao menos um formato para imprimir.",
          autoCloseTime: 8000,
        });
        setModalVisible(false);
        setTipoFolha("A4");
        return;
      }

      setBloquearBotao(true);

      const params = {
        tipoFolha,
        etiqueta: imprimirEtiqueta,
        dace: imprimirDace,
      };
      if (imprimirEtiqueta) {
        params.uuids = freteSelecionado.map((f) => f.uuid);
      }
      if (imprimirDace) {
        params.requestCodes = freteSelecionado
          .filter((f) => f.sefazDceUuid)
          .map((f) => f.sefazDceUuid);
      }

      freteService.imprimir(params).then(
        (response) => {
          const { data } = response;
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          if (isIOS) {
            downloadService.downloadFile({
              label: "impressao",
              data: data,
              filename: "impressao.pdf",
              extension: "pdf",
            });
          } else {
            downloadService.abrirFileNovaAba({
              label: "impressao",
              data: data,
              filename: "impressao.pdf",
              extension: "pdf",
            });
          }
          setBloquearBotao(false);
        },
        (error) => {
          setErro({
            isWrong: true,
            titulo: "Erro ao imprimir",
            mensagem: "Não foi possível gerar a impressão.",
            autoCloseTime: 8000,
          });
          console.error("Erro ao imprimir:", error);
          setBloquearBotao(false);
        }
      );
    } else {
      setBloquearBotao(false);
    }
    setModalVisible(false);
    setTipoFolha("A4");
  };

  const comprovantePostagem = () => {
    setBloquearBotao(true);

    const base = freteSelecionado.length > 0 ? freteSelecionado : fretes;
    const uuids = base.map((f) => f.uuid);

    Promise.all([
      etiquetaService.gerarComprovantePostagem("pdf", uuids),
      etiquetaService.gerarComprovantePostagem("csv", uuids),
    ])
      .then(([responsePdf, responseCsv]) => {
        downloadService.downloadFile({
          label: "comprovante",
          data: responsePdf.data,
          filename: "comprovante-postagem.pdf",
          extension: "pdf",
        });
        setTimeout(() => {
          downloadService.downloadFile({
            label: "comprovante",
            data: responseCsv.data,
            filename: "comprovante-postagem.csv",
            extension: "csv",
          });
        }, 300);
        setBloquearBotao(false);
      })
      .catch((error) => {
        console.error("Erro ao gerar comprovante:", error);
        setErro({
          isWrong: true,
          titulo: "Erro ao gerar comprovante",
          mensagem: "Não foi possível gerar o comprovante de postagem.",
          autoCloseTime: 8000,
        });
        setBloquearBotao(false);
      });
  };

  const buildPayload = (currentRequest) => {
    const payload = { ...currentRequest };
    if (payload.nomeDestinatario && payload.nomeDestinatario.length === 0)
      delete payload.nomeDestinatario;
    if (payload.cpfCnpj && payload.cpfCnpj.length === 0) delete payload.cpfCnpj;
    if (payload.codigoEncomenda && payload.codigoEncomenda.length === 0)
      delete payload.codigoEncomenda;
    if (payload.cepDestino && payload.cepDestino.length === 0) delete payload.cepDestino;
    if (payload.transportadora && payload.transportadora.length === 0)
      delete payload.transportadora;
    if (payload.lojas?.length === 0) delete payload.lojas;
    return payload;
  };

  const loadFretes = useCallback(() => {
    setIsLoading(true);
    const payload = buildPayload(request);

    freteService.listarMeusFretes(payload, (err, sucesLoad) => {
      setIsLoading(false);
      if (err) {
        console.error(err);
      } else {
        limparSelecao();
        setfretes([...sucesLoad]);
      }
    });
  }, [request]);

  const loadMoreFretes = () => {
    setIsLoading(true);
    const nextRequest = { ...request, page: request.page + 1 };
    setRequest(nextRequest);

    const payload = buildPayload(nextRequest);

    freteService.listarMeusFretes(payload, (err, sucessLoadMore) => {
      setIsLoading(false);
      if (err) {
        console.error(err);
      } else {
        if (sucessLoadMore.length) {
          if (checkedAll) {
            setCheckedAll(false);
            setLabelCheckAll("Selecionar todos");
          }
          setfretes([...fretes, ...sucessLoadMore]);
        }
      }
    });
  };

  const showHideElementCallback = (index) => {
    const showAux = showingItems;
    showAux[index] = !showingItems[index];
    setShowingItems([...showAux]);
  };

  useEffect(() => {
    loadFretes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const callback = () => {
      loadFretes();
    };
    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    const callback = () => {
      if (submitSearchForm) {
        loadFretes();
        setSubmitSearchForm(false);
      }
    };
    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitSearchForm, loadFretes]);

  const submitForm = (e) => {
    e.preventDefault();
    setRequest((prev) => ({ ...prev, page: 0 }));
    setfretes([]);
    setSubmitSearchForm(true);
  };

  const onClickChangeStatusFrete = (statusFrete) => {
    if (statusFrete === request.status) {
      return;
    }
    setRequest((prev) => ({
      page: 0,
      pageSize: prev.pageSize,
      status: statusFrete,
      dataInicio: "",
      dataFim: "",
      nomeDestinatario: [],
      cpfCnpj: [],
      codigoEncomenda: [],
      cepDestino: [],
      transportadora: [],
      lojas: [],
    }));
    setStatus(statusFrete);
  };

  const deleteFrete = (frete, index) => {
    if (frete.statusFrete === "CANCELADO" || frete.statusFrete === "EXPIRADO") {
      return;
    }
    if (!window.confirm("Tem certeza que deseja cancelar o frete?")) {
      return;
    }
    setIsLoading(true);
    const mensagem = "Cancelamento solicitado pelo assinante.";
    freteService.deleteFrete(frete.uuid, mensagem, (err, sucessoFreteDelete) => {
      setIsLoading(false);
      if (err) {
        setErro({
          isWrong: true,
          titulo: "Cancelamento de frete",
          mensagem: "Não foi possivel cancelar o frete.",
          autoCloseTime: 8000,
        });
      } else {
        const { cancelado, status } = sucessoFreteDelete.data;
        const mensagem =
          cancelado === false && status === "PROCESSANDO_CANCELAMENTO"
            ? "O cancelamento está sendo processado, frete será atualizado em alguns minutos ..."
            : "Seu frete foi cancelado com sucesso.";
        setSucesso({
          isWrong: false,
          titulo: "Cancelamento de frete",
          mensagem,
          autoCloseTime: 8000,
        });
        if (cancelado === true) {
          fretes.splice(index, 1);
        }
      }
    });
  };

  const [erro, setErro] = useState({
    isWrong: false,
    titulo: "",
    mensagem: "",
    voltar: false,
    autoCloseTime: 8000,
  });

  const [sucess, setSucesso] = useState({
    isWrong: true,
    titulo: "",
    mensagem: "",
    voltar: false,
    autoCloseTime: 8000,
  });

  const callbackModal = () => {
    if (erro.isWrong === true) {
      setErro({ isWrong: false });
    }
  };

  const callbackModalSucesso = () => {
    if (sucess.isWrong === false) {
      setSucesso({ isWrong: true });
    }
  };

  const checkboxJsx = () => {
    return (
      <div className="columns is-vcentered is-multiline mt-4">
        <div className="column is-full-mobile is-narrow">
          <label className="checkbox ffl-custom-checkbox is-flex is-align-items-center">
            <input
              checked={checkedAll}
              onChange={(e) => {
                handleFreteChangeAll(e.target.checked);
              }}
              type="checkbox"
            />
            <span className="ml-2">{labelCheckAll}</span>
          </label>
        </div>
        <div className="column is-full-mobile">
          <button
            disabled={freteSelecionado.length === 0 || bloquearBotao}
            className={`button button-purple w-100 ${bloquearBotao ? "is-loading" : ""}`}
            onClick={etiquetasLoteModal}
            type="button"
          >
            {bloquearBotao ? "Imprimindo ...." : "Imprimir"}
          </button>
        </div>
        {isSeller && ( // Aparece somente para usuários SELLERs
          <div className="column is-full-mobile">
            <button
              disabled={bloquearBotao}
              className={`button button-purple w-100 ${bloquearBotao ? "is-loading" : ""}`}
              onClick={comprovantePostagem}
              type="button"
            >
              {bloquearBotao ? "Baixando comprovante ..." : "Baixar Comprovante"}
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <Container>
      <GlobalFilterStyle />
      <ModalEnvios
        visivel={isModalVisible}
        titulo="Imprimir"
        labelConfirmButton="Imprimir"
        labelCancelButton="Cancelar"
        onChange={imprimir}
      >
        <div className="columns is-multiline is-centered">
          <div className="column is-full-mobile is-narrow">
            <label className="checkbox ffl-custom-checkbox is-flex is-align-items-center">
              <input
                checked={imprimirEtiqueta}
                onChange={(e) => setImprimirEtiqueta(e.target.checked)}
                type="checkbox"
              />
              <span className="ml-2">Etiquetas</span>
            </label>
          </div>
          <div className="column is-full-mobile is-narrow">
            <label className="checkbox ffl-custom-checkbox is-flex is-align-items-center">
              <input
                checked={imprimirDace}
                onChange={(e) => setImprimirDace(e.target.checked)}
                type="checkbox"
              />
              <span className="ml-2">DACE/DCE</span>
            </label>
          </div>
        </div>
        <p>Selecione o formato de impressão:</p>
        <div className="select">
          <select value={tipoFolha} onChange={handleSelectChange}>
            {tiposImpressao.map((tipo, index) => {
              return (
                <option key={index} value={tipo.value}>
                  {tipo.label}
                </option>
              );
            })}
          </select>
        </div>
      </ModalEnvios>
      {erro.isWrong === true ? (
        <Modal
          callbackModal={callbackModal}
          visivel={erro.isWrong === true}
          titulo={erro.titulo}
          conteudo={erro.mensagem}
          autoCloseTime={erro.autoCloseTime}
        />
      ) : null}

      {sucess.isWrong === false ? (
        <Modal
          callbackModal={callbackModalSucesso}
          visivel={sucess.isWrong === false}
          titulo={sucess.titulo}
          conteudo={sucess.mensagem}
          autoCloseTime={sucess.autoCloseTime}
        />
      ) : null}

      {isLoading ? <FlexSpinner className="spinner" /> : ""}

      <div className="meus-envios-cabecalho container-desktop">
        <ul>
          <SelectStatusFreteStyle
            $selected={status === "PENDENTE"}
            to="envios?section=PENDENTE"
            onClick={(e) => onClickChangeStatusFrete("PENDENTE")}
          >
            Pendentes
          </SelectStatusFreteStyle>
          <SelectStatusFreteStyle
            $selected={status === "GERADO"}
            to="envios?section=GERADO"
            onClick={(e) => onClickChangeStatusFrete("GERADO")}
          >
            Gerados
          </SelectStatusFreteStyle>
          <SelectStatusFreteStyle
            $selected={status === "POSTADO"}
            to="envios?section=POSTADO"
            onClick={(e) => onClickChangeStatusFrete("POSTADO")}
          >
            Postados
          </SelectStatusFreteStyle>
          <SelectStatusFreteStyle
            $selected={status === "ENTREGUE"}
            to="envios?section=ENTREGUE"
            onClick={(e) => onClickChangeStatusFrete("ENTREGUE")}
          >
            Entregues
          </SelectStatusFreteStyle>
          <SelectStatusFreteStyle
            $selected={status === "EXPIRADO"}
            to="envios?section=EXPIRADO"
            onClick={(e) => onClickChangeStatusFrete("EXPIRADO")}
          >
            Expirados
          </SelectStatusFreteStyle>
          <SelectStatusFreteStyle
            $selected={status === "CANCELADO"}
            to="envios?section=CANCELADO"
            onClick={(e) => onClickChangeStatusFrete("CANCELADO")}
          >
            Cancelados
          </SelectStatusFreteStyle>
        </ul>
      </div>

      <div className="container-mobile">
        <div className="mb-3">
          <Swiper
            pagination={true}
            modules={[Pagination]}
            onSlideChange={(swiper) => setComoFuncionaPosition(swiper.activeIndex)}
          >
            <SwiperSlide>
              <div className="itens-mobile">
                <SelectStatusFreteStyle
                  $selected={status === "PENDENTE"}
                  to="envios?section=PENDENTE"
                  onClick={(e) => onClickChangeStatusFrete("PENDENTE")}
                >
                  Pendentes
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "GERADO"}
                  to="envios?section=GERADO"
                  onClick={(e) => onClickChangeStatusFrete("GERADO")}
                >
                  Gerados
                </SelectStatusFreteStyle>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="itens-mobile">
                <SelectStatusFreteStyle
                  $selected={status === "PENDENTE"}
                  to="envios?section=PENDENTE"
                  onClick={(e) => onClickChangeStatusFrete("PENDENTE")}
                >
                  Pendentes
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "GERADO"}
                  to="envios?section=GERADO"
                  onClick={(e) => onClickChangeStatusFrete("GERADO")}
                >
                  Gerados
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "POSTADO"}
                  to="envios?section=POSTADO"
                  onClick={(e) => onClickChangeStatusFrete("POSTADO")}
                >
                  Postados
                </SelectStatusFreteStyle>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="itens-mobile">
                <SelectStatusFreteStyle
                  $selected={status === "GERADO"}
                  to="envios?section=GERADO"
                  onClick={(e) => onClickChangeStatusFrete("GERADO")}
                >
                  Gerados
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "POSTADO"}
                  to="envios?section=POSTADO"
                  onClick={(e) => onClickChangeStatusFrete("POSTADO")}
                >
                  Postados
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "ENTREGUE"}
                  to="envios?section=ENTREGUE"
                  onClick={(e) => onClickChangeStatusFrete("ENTREGUE")}
                >
                  Entregues
                </SelectStatusFreteStyle>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="itens-mobile">
                <SelectStatusFreteStyle
                  $selected={status === "POSTADO"}
                  to="envios?section=POSTADO"
                  onClick={(e) => onClickChangeStatusFrete("POSTADO")}
                >
                  Postados
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "ENTREGUE"}
                  to="envios?section=ENTREGUE"
                  onClick={(e) => onClickChangeStatusFrete("ENTREGUE")}
                >
                  Entregues
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "EXPIRADO"}
                  to="envios?section=EXPIRADO"
                  onClick={(e) => onClickChangeStatusFrete("EXPIRADO")}
                >
                  Expirados
                </SelectStatusFreteStyle>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="itens-mobile">
                <SelectStatusFreteStyle
                  $selected={status === "EXPIRADO"}
                  to="envios?section=EXPIRADO"
                  onClick={(e) => onClickChangeStatusFrete("EXPIRADO")}
                >
                  Expirados
                </SelectStatusFreteStyle>
                <SelectStatusFreteStyle
                  $selected={status === "CANCELADO"}
                  to="envios?section=CANCELADO"
                  onClick={(e) => onClickChangeStatusFrete("CANCELADO")}
                >
                  Cancelados
                </SelectStatusFreteStyle>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="dots mobile-container" style={{ justifyContent: "center" }}>
          <span
            style={{ backgroundColor: comoFuncionaPosition === 0 ? "#EBB013" : "white" }}
          ></span>
          <span
            style={{ backgroundColor: comoFuncionaPosition === 1 ? "#EBB013" : "white" }}
          ></span>
          <span
            style={{ backgroundColor: comoFuncionaPosition === 2 ? "#EBB013" : "white" }}
          ></span>
          <span
            style={{ backgroundColor: comoFuncionaPosition === 3 ? "#EBB013" : "white" }}
          ></span>
          <span
            style={{ backgroundColor: comoFuncionaPosition === 4 ? "#EBB013" : "white" }}
          ></span>
        </div>
      </div>

      <FreteListSearchForm>
        <form onSubmit={(e) => submitForm(e)}>
          <div className="formulario-busca-header">
            <div className="formulario-titulo">
              <h2 className="formulario-busca-titulo">Pesquisar</h2>
            </div>
            <div
              className="formulario-busca-inputs"
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <div
                className="filtros-paginas"
                ref={paginasFiltrosRef}
                onScroll={(e) => {
                  const el = e.currentTarget;
                  setPosicaoFiltros(Math.round(el.scrollLeft / el.clientWidth));
                }}
              >
                {/* primeira linha */}
                <div style={{ display: "flex", flexWrap: "nowrap", gap: "1rem", width: "100%" }}>
                  <div
                    className="formulario-busca-input-area"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="nomeDestinatario">Nome do destinatário</label>
                    <MultiSelect
                      value={request.nomeDestinatario}
                      options={nomeDestinatarios}
                      onChange={(e) =>
                        setRequest((prev) => ({ ...prev, nomeDestinatario: e.value }))
                      }
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Todos"
                      maxSelectedLabels={0}
                      selectedItemsLabel={
                        request.nomeDestinatario?.length === nomeDestinatarios.length
                          ? "Todos"
                          : "{0} itens selecionados"
                      }
                      filter
                      filterPlaceholder="Pesquisar"
                      emptyMessage="Nenhum nome encontrado"
                      className="multiselect-custom"
                      appendTo={document.body}
                      panelClassName="custom-filter-panel"
                      style={{ width: "100%" }}
                      itemTemplate={(option) => (
                        <div
                          style={{
                            padding: "0.5rem 1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                          }}
                          title={option.label}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className="formulario-busca-input-area"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="cpfCnpj">CPF/CNPJ do destinatário</label>
                    <MultiSelect
                      value={request.cpfCnpj}
                      options={cpfCnpjs}
                      onChange={(e) => setRequest((prev) => ({ ...prev, cpfCnpj: e.value }))}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Todos"
                      maxSelectedLabels={0}
                      selectedItemsLabel={
                        request.cpfCnpj?.length === cpfCnpjs.length
                          ? "Todos"
                          : "{0} itens selecionados"
                      }
                      filter
                      filterPlaceholder="Pesquisar"
                      emptyMessage="Nenhum CPF encontrado"
                      className="multiselect-custom"
                      appendTo={document.body}
                      panelClassName="custom-filter-panel"
                      style={{ width: "100%" }}
                      itemTemplate={(option) => (
                        <div
                          style={{
                            padding: "0.5rem 1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                          }}
                          title={option.label}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className="formulario-busca-input-area"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="codigoEncomenda">Código da encomenda</label>
                    <MultiSelect
                      value={request.codigoEncomenda}
                      options={codigosEncomenda}
                      onChange={(e) =>
                        setRequest((prev) => ({ ...prev, codigoEncomenda: e.value }))
                      }
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Todos"
                      maxSelectedLabels={0}
                      selectedItemsLabel={
                        request.codigoEncomenda?.length === codigosEncomenda.length
                          ? "Todos"
                          : "{0} itens selecionados"
                      }
                      filter
                      filterPlaceholder="Pesquisar"
                      emptyMessage="Nenhum código encontrado"
                      className="multiselect-custom"
                      appendTo={document.body}
                      panelClassName="custom-filter-panel"
                      style={{ width: "100%" }}
                      itemTemplate={(option) => (
                        <div
                          style={{
                            padding: "0.5rem 1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                          }}
                          title={option.label}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className="formulario-busca-input-area"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="cepDestino">CEP de destino</label>
                    <MultiSelect
                      value={request.cepDestino}
                      options={cepsDestino}
                      onChange={(e) => setRequest((prev) => ({ ...prev, cepDestino: e.value }))}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Todos"
                      maxSelectedLabels={0}
                      selectedItemsLabel={
                        request.cepDestino?.length === cepsDestino.length
                          ? "Todos"
                          : "{0} itens selecionados"
                      }
                      filter
                      filterPlaceholder="Pesquisar"
                      emptyMessage="Nenhum CEP encontrado"
                      className="multiselect-custom"
                      appendTo={document.body}
                      panelClassName="custom-filter-panel"
                      style={{ width: "100%" }}
                      itemTemplate={(option) => (
                        <div
                          style={{
                            padding: "0.5rem 1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                          }}
                          title={option.label}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                </div>
                {/* segunda linha */}
                <div style={{ display: "flex", flexWrap: "nowrap", gap: "1rem", width: "100%" }}>
                  <div
                    className="formulario-busca-input-area"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="transportadora">Transportadora</label>
                    <MultiSelect
                      value={request.transportadora}
                      options={transportadoras}
                      onChange={(e) => setRequest((prev) => ({ ...prev, transportadora: e.value }))}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Todos"
                      maxSelectedLabels={0}
                      selectedItemsLabel={
                        request.transportadora?.length === transportadoras.length
                          ? "Todos"
                          : "{0} itens selecionados"
                      }
                      filter
                      filterPlaceholder="Pesquisar"
                      emptyMessage="Nenhuma transportadora encontrada"
                      className="multiselect-custom"
                      appendTo={document.body}
                      panelClassName="custom-filter-panel"
                      style={{ width: "100%" }}
                      itemTemplate={(option) => (
                        <div
                          style={{
                            padding: "0.5rem 1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                          }}
                          title={option.label}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className="formulario-busca-input-area calendar"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="dataInicio">Período de Início</label>
                    <input
                      type="date"
                      className="input"
                      name="dataInicio"
                      onChange={(e) =>
                        setRequest((prev) => ({ ...prev, dataInicio: e.target.value }))
                      }
                      value={request.dataInicio}
                    />
                  </div>
                  <div
                    className="formulario-busca-input-area calendar"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="dataFim">Período de término</label>
                    <input
                      type="date"
                      className="input"
                      name="dataFim"
                      onChange={(e) => setRequest((prev) => ({ ...prev, dataFim: e.target.value }))}
                      value={request.dataFim}
                    />
                  </div>
                  <div
                    className="formulario-busca-input-area quantidade-fretes"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="quantidade_fretes">Quantidade de fretes</label>
                    <div className="select">
                      <select
                        name="quantidade_fretes"
                        onChange={(e) =>
                          setRequest((prev) => ({ ...prev, pageSize: Number(e.target.value) }))
                        }
                        value={request.pageSize}
                      >
                        <option value="10">10 fretes</option>
                        <option value="20">20 fretes</option>
                        <option value="30">30 fretes</option>
                        <option value="50">50 fretes</option>
                        <option value="100">100 fretes</option>
                        <option value="500">500 fretes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dots-filtros">
                {[0, 1].map((i) => (
                  <button
                    key={i}
                    type="button"
                    aria-label={`Ir para a página ${i + 1} de filtros`}
                    onClick={() => {
                      const el = paginasFiltrosRef.current;
                      if (!el) return;
                      el.scrollTo({
                        left: el.children[i].offsetLeft - el.children[0].offsetLeft,
                        behavior: "smooth",
                      });
                    }}
                    style={{ backgroundColor: posicaoFiltros === i ? "#EBB013" : "#ddd" }}
                  />
                ))}
              </div>
              {/* terceira linha - filtro de loja (apenas para Seller) */}
              {isSeller && (
                <div style={{ display: "flex", flexWrap: "nowrap", gap: "1rem", width: "100%" }}>
                  <div
                    className="formulario-busca-input-area"
                    style={{ flex: "1 1 23%", minWidth: "200px" }}
                  >
                    <label htmlFor="lojas">Loja</label>
                    <MultiSelect
                      value={request.lojas}
                      options={lojas}
                      onChange={(e) => setRequest((prev) => ({ ...prev, lojas: e.value }))}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Todas"
                      maxSelectedLabels={0}
                      selectedItemsLabel={
                        request.lojas?.length === lojas.length ? "Todas" : "{0} itens selecionados"
                      }
                      filter
                      filterPlaceholder="Pesquisar"
                      emptyMessage="Nenhuma loja encontrada"
                      className="multiselect-custom"
                      panelClassName="custom-filter-panel"
                      appendTo={document.body}
                      style={{ width: "100%" }}
                      itemTemplate={(option) => (
                        <div
                          style={{
                            padding: "0.5rem 1rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                          }}
                          title={option.label}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                </div>
              )}
              {/* botao centralizado */}
              <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                <button className="button buscar-button" type="submit">
                  Buscar
                </button>
              </div>
            </div>

            {(status === "GERADO" || status === "POSTADO" || status === "ENTREGUE") &&
              fretes.length > 0 &&
              checkboxJsx()}
          </div>
        </form>
        <ul className="frete-list">
          {fretes.map((frete, index) => (
            <MeusenviosFrete
              frete={frete}
              key={frete.uuid}
              deleteFreteCallback={deleteFrete}
              showBody={showingItems[index]}
              setShowBodyCallback={showHideElementCallback}
              index={index}
              status={status}
              handleFreteChange={handleFreteChange}
            />
          ))}
        </ul>

        {fretes.length >= request.pageSize ? (
          <input
            className="button loadmore-button"
            value="Carregar mais"
            onClick={loadMoreFretes}
          />
        ) : (
          ""
        )}
      </FreteListSearchForm>
    </Container>
  );
}
